module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/accountadmin/img_logo_white.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Accounts Management")]), _vm._v(" "), _c('img', {
    staticClass: "logout",
    attrs: {
      "src": "/static/accountadmin/icon_out.png"
    },
    on: {
      "click": _vm.logout
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "username"
  }, [_vm._v("Hello  " + _vm._s(_vm.username))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f96cad5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/AccountAdminMainHeader.vue
// module id = 1479
// module chunks = 7